module.exports = __webpack_public_path__ + "img/en.0eb3abb3.svg";